import { Status68DEnum } from '../../../../store/generated/portal/userContext';

export enum RECORD_TYPES {
  TEXT = '1',
  NUMBER = '2',
  DECIMAL = '3',
  DATE = '4',
}

/**
 * Determines if an employee status is considered "active" for UI purposes
 * @param status - The status code to check
 * @returns True if the status is considered active, false otherwise
 */
export const isEmployeeStatusActive = (status?: Status68DEnum): boolean =>
  status === 1 || status === 2; // Active or Paused

/**
 * Interface for the result of demographic validation
 */
export interface DemographicValidationResult {
  valid: boolean;
  missingValues?: string[];
}

/**
 * Validates that an employee has all required demographic properties
 * @param employee - The employee object to validate
 * @param demographicFields - The array of demographic fields to check
 * @returns An object with a boolean 'valid' property and an optional 'missingValues' array
 */
export const validateEmployeeDemographics = (
  employee: any,
  demographicFields: any[]
): DemographicValidationResult => {
  if (!demographicFields || demographicFields.length === 0) {
    return { valid: true };
  }

  const missingValues: string[] = [];

  demographicFields.forEach((field: any) => {
    // Check if the employee has a value for this demographic field
    if (!employee[field.name] || employee[field.name].trim() === '') {
      missingValues.push(field.name);
    }
  });

  return {
    valid: missingValues.length === 0,
    missingValues: missingValues.length > 0 ? missingValues : undefined,
  };
};
